<ng-template #previewChat>
  <chat-message-hover [chat]="chatOnHover"> </chat-message-hover>
</ng-template>
<div
  class="chat-banner-main-area"
  id="chatBanner"
  [ngClass]="{ 'chat-banner-main-area-color': showBanner, 'chat-banner-agent-menu-open': showAgentMenu }"
>
  <div class="chat-banner" id="chat-banner">
    <div class="chat-banner-left-section">
      <span aria-hidden="true" class="cng-ico_chat2"></span>
    </div>
    <div class="chat-banner-right-section">
      <div [attr.aria-hidden]="!showBanner" id="chat-banner-conversation">
        <ul class="chat-banner-open" *ngIf="showBanner">
          <li
            class="chat-banner-tab"
            *ngFor="let chat of chatSocketService.chatList"
            [class.animate]="chat.isNew"
            (click)="selectChat(chat)"
            [cngTooltip]="previewChat"
            (shown)="chatOnHover = chat"
            [disabled]="isSelected(chat)"
            tooltipClass="white"
            placement="top"
          >
            <button
              class="chat-banner-tab-active"
              [ngClass]="isSelected(chat) ? 'chat-selected' : 'chat-not-selected'"
              *ngIf="!chat.tab.closedByClient && chat.chatSlaConf && !chat.inPostTreatmentMode && !chat.tab.conversationEndByClient"
            >
              <div
                class="chat-banner-tab-content"
                [ngClass]="{ 'duration-exceeded': chat.tab.isLastMessageFromClient && chat.durationExceeded() && !isSelected(chat) }"
              >
                <span class="chat-banner-tab-header" [class.chat-banner-tab-header-with-mirroring]="screenSharingActivated(chat)">
                  <span
                    [ngClass]="{ 'sla-reminder': chat.timeBeforeReminderExceeded(), 'active-chat-sla': isSelectedSlaExceeded(chat) }"
                    *ngIf="chat.tab.isLastMessageFromClient"
                  >
                    <time [dateTime]="getTimerForLastMessageValue(chat)">{{ getTimerForLastMessageValue(chat) | elapsedTime }}</time>
                    <time *ngIf="chat.timeBeforeReminderExceeded()">({{ getTimeBeforeDurationCountdown(chat) | elapsedTime }}')</time>
                    <time *ngIf="chat.durationExceeded()">(+{{ getSlaTimer(chat) | elapsedTime: true }}')</time>
                  </span>
                  <span [ngClass]="{ 'before-chatName': chat.tab.isLastMessageFromClient && !isSelectedSlaExceeded(chat) }">
                    <span *ngIf="chat.tab.chatName">{{ chat.tab.chatName | translate | uppercase }}</span>
                  </span>
                  <span
                    [ngClass]="{
                      'cng-ico_partage_page selected-sharing-icon-position': screenSharingActivated(chat) && isSelected(chat),
                      'cng-ico_cobrowsing sharing-icon-position': screenSharingActivated(chat) && !isSelected(chat)
                    }"
                  ></span>
                </span>
                <span
                  class="counter"
                  [ngClass]="chat.durationExceeded() && !isSelected(chat) ? 'duration-exceeded-tab-counter' : 'tab-counter'"
                  *ngIf="chat.tab.hasNewMessage()"
                  title="{{ 'agent:panel.chat.banner.chat-new-messages-count-title' | translate }}"
                  >{{ chat.tab.newMessagesCount }}</span
                >
                <span
                  class="chat-banner-message-text"
                  title="{{ 'agent:panel.chat.banner.chat-last-message-title' | translate }}"
                  *ngIf="chat.messages[0] && chat.messages[0].isFromCustomer()"
                  [innerHTML]="getMessageContent(chat.tab.lastMessage)"
                  >{{ getMessageContent(chat.tab.lastMessage) }}</span
                >
                <span
                  class="chat-banner-message-text"
                  title="{{ 'agent:panel.chat.banner.chat-last-message-title' | translate }}"
                  *ngIf="chat.messages[0] && !chat.messages[0].isFromCustomer()"
                  [innerHTML]="getMessageContentWithUrl(chat.tab.lastMessage)"
                  >{{ getMessageContentWithUrl(chat.tab.lastMessage) }}</span
                >
              </div>
            </button>
            <button
              class="chat-banner-tab-active"
              [ngClass]="isSelected(chat) ? 'chat-selected' : 'chat-not-selected'"
              *ngIf="!chat.tab.closedByClient && !chat.chatSlaConf && !chat.inPostTreatmentMode && !chat.tab.conversationEndByClient"
            >
              <div class="chat-banner-tab-content">
                <span class="chat-banner-tab-header" [class.chat-banner-tab-header-with-mirroring]="screenSharingActivated(chat)">
                  <time *ngIf="chat.tab.isLastMessageFromClient" [dateTime]="getTimerForLastMessageValue(chat)">{{
                    getTimerForLastMessageValue(chat) | elapsedTime
                  }}</time>
                  <span [ngClass]="{ 'before-chatName': chat.tab.isLastMessageFromClient }">
                    <span *ngIf="chat.tab.chatName" title="{{ chat.tab.chatName | translate }}">
                      {{ chat.tab.chatName | translate | uppercase }}</span
                    >
                  </span>
                  <span
                    [ngClass]="{
                      'cng-ico_partage_page selected-sharing-icon-position': screenSharingActivated(chat) && isSelected(chat),
                      'cng-ico_cobrowsing sharing-icon-position': screenSharingActivated(chat) && !isSelected(chat)
                    }"
                  ></span>
                </span>
                <span
                  class="counter tab-counter"
                  *ngIf="chat.tab.hasNewMessage()"
                  title="{{ 'agent:panel.chat.banner.chat-new-messages-count-title' | translate }}"
                  >{{ chat.tab.newMessagesCount }}</span
                >
                <span
                  class="chat-banner-message-text"
                  title="{{ 'agent:panel.chat.banner.chat-last-message-title' | translate }}"
                  *ngIf="chat.messages[0] && chat.messages[0].isFromCustomer()"
                  [innerHTML]="getMessageContent(chat.tab.lastMessage)"
                  >{{ getMessageContent(chat.tab.lastMessage) }}</span
                >
                <span
                  class="chat-banner-message-text"
                  title="{{ 'agent:panel.chat.banner.chat-last-message-title' | translate }}"
                  *ngIf="chat.messages[0] && !chat.messages[0].isFromCustomer()"
                  [innerHTML]="getMessageContentWithUrl(chat.tab.lastMessage)"
                  >{{ getMessageContentWithUrl(chat.tab.lastMessage) }}</span
                >
              </div>
            </button>
            <button
              class="chat-banner-tab-active"
              [ngClass]="isSelected(chat) ? 'chat-selected' : 'chat-not-selected'"
              *ngIf="chat.inPostTreatmentMode"
            >
              <div class="chat-banner-tab-content">
                <span class="chat-banner-tab-header" [class.chat-banner-tab-header-with-mirroring]="screenSharingActivated(chat)">
                  <span *ngIf="chat.tab.chatName"> {{ chat.tab.chatName | translate | uppercase }}</span>
                  <span class="post-treatment-time-exceeded" *ngIf="postTreatmentDurationExceeded(chat)">
                    <span class="cng-ico_add plus"></span>
                    <time class="deadline-time">{{ getPostTreatmentExceededTimerValue(chat) | elapsedTime }}</time>
                  </span>
                </span>
                <span class="chat-banner-post-treatment-text" *ngIf="!postTreatmentDurationExceeded(chat)"
                  >{{ 'agent:panel.chat.banner.chat-post-treatment' | translate }}
                  <time>({{ getPostTreatmentTimerValue(chat) | elapsedTime }}')</time>
                </span>
                <span class="chat-banner-post-treatment-text" *ngIf="postTreatmentDurationExceeded(chat)">
                  {{ 'agent:panel.chat.banner.chat-post-treatment-after-deadline' | translate }}
                </span>
              </div>
            </button>

            <button
              class="chat-banner-tab-inactive"
              [ngClass]="isSelected(chat) ? 'chat-selected' : 'chat-not-selected'"
              *ngIf="chat.tab.conversationEndByClient && !chat.inPostTreatmentMode"
            >
              <div class="chat-banner-tab-content">
                <span class="chat-banner-tab-header" [class.chat-banner-tab-header-with-mirroring]="screenSharingActivated(chat)">
                  <span *ngIf="chat.tab.chatName"> {{ chat.tab.chatName | translate | uppercase }}</span>
                </span>
                <span class="chat-banner-close-status-text red">{{
                  'agent:panel.chat.banner.contact_close_chat_status_text' | translate
                }}</span>
              </div>
            </button>

            <button
              class="chat-banner-tab-inactive"
              [ngClass]="isSelected(chat) ? 'chat-selected' : 'chat-not-selected'"
              *ngIf="chat.tab.closedByClient && !chat.inPostTreatmentMode"
            >
              <div class="chat-banner-tab-content">
                <span class="chat-banner-tab-header" [class.chat-banner-tab-header-with-mirroring]="screenSharingActivated(chat)">
                  <span *ngIf="chat.tab.chatName"> {{ chat.tab.chatName | translate | uppercase }}</span>
                </span>
                <span class="chat-banner-close-status-text red">{{ 'agent:panel.chat.banner.close_chat_status_text' | translate }}</span>
              </div>
            </button>
          </li>
        </ul>
      </div>
      <div id="chat-banner-button">
        <button
          aria-controls="chat-banner-conversation"
          [attr.aria-expanded]="showBanner"
          [attr.aria-pressed]="showBanner"
          class="chat-banner-open-button cng-ico_page_next"
          [ngClass]="showBanner ? 'chat-banner-close-button cng-ico_page_previous' : 'chat-banner-open-button cng-ico_page_next'"
          (click)="moveBanner()"
          title="{{ 'agent:panel.chat.banner.banner_button_title' | translate }}"
        >
          <span class="nodisplay" *ngIf="showBanner">{{ 'agent:panel.chat.banner.open_banner_button_title' | translate }}</span>
          <span class="nodisplay" *ngIf="!showBanner">{{ 'agent:panel.chat.banner.close_banner_button_title' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>
